import Api from './axios'

export const appCdnUrl = `${ process.env.REACT_APP_CDN }${ process.env.REACT_APP_CDN.slice( -1 ) === '/' ? '' : '/' }`

export const MonthNames = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]
export const WeekDays   = [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ]

export const getDayName = ( date ) => {
  const dayIndex = date.getDay()
  return WeekDays[ dayIndex ]
}

const daysOfWeek = [ 'SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA' ]

export const formatGBP = ( value ) => {
  return new Intl.NumberFormat( 'en-GB', {
    style:                 'currency',
    currency:              'GBP',
    signDisplay:           'auto', // or "exceptZero"
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  } ).format( value )
}

export const formatTimeDate = ( dateInput, withTime = false ) => {
  const d = new Date( dateInput )

  const year  = d.getFullYear()
  const month = String( d.getMonth() + 1 ).padStart( 2, '0' )
  const day   = String( d.getDate() ).padStart( 2, '0' )

  let result = `${ day }.${ month }.${ year }`

  if ( withTime ) {
    const hours   = String( d.getHours() ).padStart( 2, '0' )
    const minutes = String( d.getMinutes() ).padStart( 2, '0' )
    result += ` ${ hours }:${ minutes }`
  }

  return result
}

export const getAbbreviation = ( day ) => { // day: Wednesday, Friday etc
  const formattedDay = day.substring( 0, 2 ).toUpperCase() // Taking the first two letters and converting to uppercase
  const index        = daysOfWeek.indexOf( formattedDay )
  if ( index !== -1 ) {
    return daysOfWeek[ index ]
  } else {
    return 'Invalid day'
  }
}

export const exportData = ( data, fileName, type ) => {
  const BOM = '\uFEFF';
  const blob = new Blob( [ BOM + data ], { type } )
  const url  = window.URL.createObjectURL( blob )
  const a    = document.createElement( 'a' )
  a.href     = url
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL( url )
}

export const setURLParam = ( param, value ) => {
  const url    = new URL( window.location.href )
  const params = new URLSearchParams( url.search )
  if ( value !== null ) {
    if ( params.has( param ) ) {
      params.set( param, String( value ) )
    } else {
      params.append( param, String( value ) )
    }
  } else {
    if ( params.has( param ) ) {
      params.delete( param )
    }
  }
  url.search = params.toString()
  window.history.pushState( null, '', url.toString() )
}

export const truncateText = ( q, limit = 100, ending = '...' ) => {
  if ( q.length <= 100 ) return q

  const lastSpace = q.slice( 0, limit - ending.length + 1 ).lastIndexOf( ' ' )

  return q.slice( 0, lastSpace > 0 ? lastSpace : limit - ending.length ) + ending
}

/**
 * Calculate the product price including free items (or not)
 *
 * @param item
 *
 * @returns {number}
 */
export const calculateProductPrice = item => {
  let quantity       = item.variant.quantity
  const productPrice = ( item.variant.price && item.variant.price > 0 ) ? item.variant.price : item.product.price

  const {
          hasFreeItemsPerLocation,
          freeItemsPerLocationQty,
          otpItemsAlreadyPurchased,
          itemsLeft
        } = item.product.config

  if ( hasFreeItemsPerLocation && otpItemsAlreadyPurchased < freeItemsPerLocationQty ) {
    if ( quantity <= itemsLeft ) {
      quantity = 0
    } else {
      quantity -= itemsLeft
    }
  }

  return productPrice * quantity
}

export const calculateProductsPrice = item => {
  let totalPrice = 0

  const {
          hasFreeItemsPerLocation,
          freeItemsPerLocationQty,
          otpItemsAlreadyPurchased,
          itemsLeft
        } = item.product.config

  item.variants.forEach( variant => {
    let quantity = variant.quantity
    let price    = ( variant.price && variant.price > 0 ) ? variant.price : item.product.price

    if ( hasFreeItemsPerLocation && otpItemsAlreadyPurchased < freeItemsPerLocationQty ) {
      if ( quantity <= itemsLeft ) {
        quantity = 0
      } else {
        quantity -= itemsLeft
      }
    }

    totalPrice += ( price * quantity )
  } )

  return parseFloat( totalPrice.toFixed( 2 ) )
}

export const updateV2HeaderCartCount = ( quantity ) => {
  const cartCountElement = document.getElementById( 'cart_count' )
  if ( cartCountElement ) {
    if ( quantity === 0 ) {
      cartCountElement.textContent = '0'
    } else {
      const qty = parseInt( quantity )
      let count = parseInt( cartCountElement.textContent )

      if ( !isNaN( qty ) && !isNaN( count ) && count >= 0 && count < 99 ) {
        count += qty
        cartCountElement.textContent = count.toString()
      }
    }
  }
}

const hexColours = [
  { a: '#ef4444' },
  { b: '#f97316' },
  { c: '#65a30d' }, // lime
  { d: '#2563eb' }, // blue
  { e: '#9333ea' }, // voilet
  { f: '#9333ea' }, // purple
  { g: '#c026d3' }, // fuchsia
  { h: '#ca8a04' }, // yellow
  { i: '#0284c7' }, // sky
  { j: '#ca8a04' }, // yellow
  { k: '#dc2626' }, // red
  { l: '#ea580c' }, // orange
  { m: '#65a30d' }, // lime
  { n: '#d97706' }, // amber
  { o: '#65a30d' }, // lime
  { p: '#2563eb' }, // blue
  { q: '#2563eb' }, // blue
  { r: '#9333ea' }, // pruple
  { s: '#2563eb' }, // blue
  { t: '#d97706' }, // amber
  { u: '#65a30d' }, // lime
  { v: '#2563eb' }, // blue
  { w: '#d97706' }, // amber
  { x: '#65a30d' }, // lime
  { y: '#9333ea' }, // pruple
  { z: '#e11d48' } // rose
]

export const setPrevUrl = ( url ) => {
  localStorage.setItem( 'prevUrl', url )
}

export const getPrevUrl = ( url ) => {
  return localStorage.getItem( 'prevUrl' )
}

/**
 * Generates a random string values.
 *
 * @returns {string}
 */
export const GENERATE_UUID = () => {
  let S4 = function() {
    return ( ( ( 1 + Math.random() ) * 0x10000 ) | 0 ).toString( 16 ).substring( 1 )
  }
  return ( S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4() )
}

export const GetInitials = ( name ) => {
  if ( !name ) {
    return name
  }
  const names  = name.split( ' ' )
  let initials = ''
  for ( let i = 0; i < names.length; i++ ) {
    if ( names[ i ].length > 0 ) {
      initials += names[ i ][ 0 ].toUpperCase()
    }
    if ( initials.length === 3 ) {
      break
    }
  }
  return initials
}

export const TruncateString = ( str, length ) => {
  if ( str.length > length ) {
    return str.slice( 0, length ) + '...'
  } else return str
}

export const StripHtmlTags = ( str ) => {
  if ( !str ) {
    return str
  }
  return str.replace( /<[^>]*>/g, '' )
}

export const FormatDate = ( str, format = null ) => {
  const date = containsNumbers( str ) ? new Date( parseInt( str ) * 1000 ) : new Date( str )

  if ( isNaN( date.getTime() ) ) {
    return str
  }

  const day              = date.getDate()
  const monthIndex       = date.getMonth()
  const year             = date.getFullYear()
  const hours            = date.getHours()
  const minutes          = date.getMinutes()
  const formattedHours   = hours % 12 || 12 // handle midnight
  const formattedMinutes = minutes < 10 ? `0${ minutes }` : minutes
  const ampm             = hours >= 12 ? 'PM' : 'AM'


  switch ( format ) {
    case 'hh:mmTT':
      return `${ formattedHours }:${ formattedMinutes }${ ampm }`
    case 'dd/MM/yyyy hh:mmTT':
      return `${ day }/${ monthIndex + 1 }/${ year } ${ formattedHours }:${ formattedMinutes }${ ampm }`
    case 'D MMMM yyyy at hh:mm':
      return `${ day } ${ MonthNames[ monthIndex ] } ${ year } at ${ formattedHours }:${ formattedMinutes }`
    default:
      return `${ day }/${ monthIndex + 1 }/${ year }`
  }
}

export const CountWords = ( str ) => {
  // Remove HTML tags and attributes
  str = StripHtmlTags( str )

  // if (!str) { return 0 }

  // Count the words
  const words = str.match( /\b\w+\b/g )
  return words ? words.length : 0
}

export const RemoveUnnecessaryTags = ( input ) => {
  if ( !input ) {
    return ''
  }
  // Use a regular expression to match the unnecessary tags
  const regex = /<style.*?<\/style>|<meta.*?>|<link.*?>/gs

  // Use the replace method to remove the matched tags
  const output = input.replace( regex, '' )

  return output
}


export const AvatarColour = ( name ) => {
  const n = name ? name[ 0 ].toLowerCase() : 'o'

  return hexColours.find( x => x[ n ] )[ n ]
}

export const PLUCK = ( arr, key ) => {
  return arr.map( ( item ) => item[ key ] )
}

export const formatBytes = ( bytes ) => {
  if ( bytes === 0 ) {
    return '0 B'
  }

  const k     = 1024
  const sizes = [ 'B', 'KB', 'MB', 'GB' ]
  const i     = Math.floor( Math.log( bytes ) / Math.log( k ) )

  return `${ ( bytes / Math.pow( k, i ) ).toFixed( 2 ) } ${ sizes[ i ] }`
}

export const formatDateForURL = ( url, dateString ) => {
  const date    = new Date( dateString )
  const year    = date.getFullYear()
  const month   = String( date.getMonth() + 1 ).padStart( 2, '0' ) // Month is zero-based
  const day     = String( date.getDate() ).padStart( 2, '0' )
  const hours   = String( date.getHours() ).padStart( 2, '0' )
  const minutes = String( date.getMinutes() ).padStart( 2, '0' )

  if ( isNaN( date.getTime() ) ) {
    return '' // Invalid date string, return an empty string or handle the error as needed
  }

  if ( dateString.includes( 'T' ) ) {
    // If the input string contains a time component, return both date and start_time
    return `${ url }?date=${ year }-${ month }-${ day }&start_time=${ hours }:${ minutes }`
  } else {
    // If there's no time component, return just the date
    return `${ url }?date=${ year }-${ month }-${ day }`
  }
}

/**
 * System Mapper Colours for Tailwind
 *
 * @see https://tailwindcss.com/docs/customizing-colors
 */
export const systemColours = {
  '#4f46e5': {
    name:      'indigo-600',
    divide:    'divide-indigo-500',
    cta:       'bg-indigo-800 text-white',
    secondary: 'text-indigo-200'
  },

  '#db2777': {
    name:      'pink-600',
    divide:    'divide-pink-500',
    cta:       'bg-pink-700 text-white',
    secondary: 'text-pink-500'
  },

  '#ea580c': {
    name:      'orange-600',
    divide:    'divide-orange-500',
    cta:       'bg-orange-800 text-white',
    secondary: 'text-orange-200'
  },

  '#9ca3af': {
    name:      'gray-400',
    divide:    'divide-gray-200',
    cta:       'bg-gray-500 text-black',
    secondary: 'text-gray-100'
  },

  '#2563eb': {
    name:      'blue-600',
    divide:    'divide-blue-500',
    cta:       'bg-blue-600 text-white',
    secondary: 'text-blue-200'
  },

  '#dc2626': {
    name:      'red-600',
    divide:    'divide-red-500',
    cta:       'bg-red-700 text-white',
    secondary: 'text-red-200'
  },
  // This blue was taken from https://www.bananamoondaynursery.co.uk/
  '#0091da': {
    name:      'banana-500',
    divide:    'divide-blue-400',
    cta:       'bg-white text-blue-500',
    secondary: 'text-blue-300'
  }
}

// export const priceIntToStringFormat = ( price ) => {
//   if ( ( typeof price === 'number' ) && Math.floor( price ) === price ) {
//     return `${ ( price / 100 ).toFixed( 2 ) }`
//   }
//
//   return price
// }

export const uploadFile = async ( file, folder, is_public = 'false' ) => {
  const formData = new FormData()

  formData.append( 'file', file )
  formData.append( 'is_public', is_public )
  formData.append( 'folder', folder )

  try {
    const { data } = await Api( process.env.REACT_APP_UPLOAD_HOST, 'multipart/form-data' ).post( '/', formData )

    return data[ 0 ]?.path?.length ? data[ 0 ].path : null
  } catch ( error ) {
    console.error( `Error uploading file (${ file.name }):`, error )
    return null
  }
}

export { fetchFileForView, prefetchFileAndDownload } from './fileDownload'

export const assetFilePath = ( extension ) => {
  let ext = extension || ''

  const supportedExts = [ 'jpg', 'jpeg', 'png', 'pdf', 'docx', 'doc', 'wordprocessingml.document', 'spreadsheetml.sheet', 'presentationml.presentation', 'pptx' ]

  if ( ( ext && supportedExts.includes( ext ) ) ||
       ext.includes( 'wordprocessingml.document' ) ||
       ext.includes( 'spreadsheetml.sheet' ) ||
       ext.includes( 'presentationml.presentation' )
  ) {

    if ( ext === 'doc' || ext === 'docx' || ext.includes( 'wordprocessingml.document' ) ) {
      ext = 'doc'
    }

    if ( ext === 'jpg' || ext === 'jpeg' || ext === 'jpeg' || ext === 'gif' || ext === 'png' ) {
      ext = 'image'
    }

    if ( ext.includes( 'spreadsheetml.sheet' ) ) {
      ext = 'xls'
    }

    if ( ext.includes( 'presentationml.presentation' ) || ext === 'pptx' ) {
      ext = 'pp'
    }

    return `${ process.env.REACT_APP_CDN }/assets/file-${ ext }.png`
  }

  // Return a default URL or handle unsupported extensions as needed
  return `${ process.env.REACT_APP_CDN }/assets/file-default.png`
}

export const arrayOfObjectsUniqById = ( a ) => {
  let seen = new Set()
  return a.filter( item => {
    let k = item.id
    return seen.has( k ) ? false : seen.add( k )
  } )
}

export const getSystemColourObjectByKey = ( key ) => {
  return systemColours[ key ] || systemColours[ '#2563eb' ]
}

export const containsNumbers = ( str ) => {
  return !isNaN( str ) && !isNaN( parseFloat( str ) )
}

export const capitalize = ( val ) => {
  return String( val ).charAt( 0 ).toUpperCase() + String( val ).slice( 1 )
}

export const calculateDeliveryCost = ( items ) => {
  let deliveriesAdded = []
  let deliveryCost    = 0

  items.forEach( ( item ) => {
    if ( !item.product.config.extraDelivery && !deliveriesAdded.includes( item.product.delivery_option_id ) ) {
      deliveryCost += item.delivery.amount
      deliveriesAdded.push( item.product.delivery_option_id )
    }
  } )

  return deliveryCost
}

export const variantVariationsConfig = ( variant, variantVariations ) => {
  let variations = []

  if ( !Array.isArray( variant.config ) && Object.keys( variant.config )?.length > 0 ) {
    Object.values( variant.config ).forEach( ( c ) => {
      const variantVariation = variantVariations.find( ( v ) => v.id === c )

      if ( variantVariation ) {
        variations.push( variantVariation )
      }
    } )
  }

  return variations
}

export const variantString = ( variant, variantVariations ) => {
  if ( !Array.isArray( variant.config ) && Object.keys( variant.config )?.length > 0 ) {
    let variantString = ''

    Object.values( variant.config ).forEach( ( c ) => {
      const variantVariation = variantVariations.find( ( v ) => v.id === c )

      if ( variantVariation ) {
        variantString = `${ variantString } ${ capitalize( variantVariation.variant_type ) }: ${ variantVariation.name } <br>`
      }
    } )

    return variantString.trim()
  }

  return undefined
}
